// Translation dictionary IT / EN
export const dict = {
  it: {
    nav: {
      home: "Home",
      services: "Servizi",
      equipment: "Attrezzature",
      gallery: "Galleria",
      blog: "Blog",
      reviews: "Recensioni",
      areas: "Zone",
      about: "Chi siamo",
      contact: "Contatti",
      call: "Chiama",
      whatsapp: "WhatsApp",
      emergency: "Emergenza H24",
    },
    common: {
      call_now: "Parla con un tecnico",
      call_now_short: "Chiama H24",
      whatsapp: "WhatsApp",
      get_quote: "Richiedi preventivo",
      open_chat: "Apri assistente",
      h24: "H24",
      open_now: "Disponibili adesso",
      free_quote: "Preventivo gratuito",
      learn_more: "Scopri di più",
      read_more: "Leggi tutto",
      submit: "Invia",
      sending: "Invio...",
      back: "Indietro",
      view_all: "Vedi tutti",
      areas_we_serve: "Zone servite",
      see_all_areas: "Vedi tutte le zone",
      our_equipment: "Le nostre attrezzature",
    },
    hero: {
      eyebrow: "Pronto intervento perdite acqua • Reperibilità telefonica H24",
      h1_line1: "Troviamo la perdita",
      h1_line2: "senza demolizioni inutili.",
      sub: "Ricerca perdite acqua in Toscana, Liguria, Umbria e Alto Lazio. Geofono HL7000, termocamera FLIR e gas tracciante non tossico. Preventivo prima di iniziare, foto-report a fine lavoro.",
      trust: ["Diagnosi non invasiva ove possibile", "Preventivo scritto prima di iniziare", "Foto-report incluso"],
    },
    home: {
      services_title: "Cosa risolviamo",
      services_sub: "Tutto quello che riguarda perdite e infiltrazioni — con strumenti professionali e zero panico.",
      equipment_title: "Strumenti di precisione",
      equipment_sub: "Niente demolizioni a caso. Solo diagnosi mirata.",
      gallery_title: "Interventi recenti",
      gallery_sub: "Foto dei nostri sopralluoghi e riparazioni.",
      reviews_title: "Cosa dicono i clienti",
      reviews_sub: "Recensioni pubblicate sul nostro profilo Google Business.",
      coverage_title: "Dove operiamo",
      coverage_sub: "15 province in Toscana, Liguria, Umbria e Alto Lazio.",
      faq_title: "Domande frequenti",
      bill_alert_title: "Bolletta dell'acqua altissima? Spesso è una perdita occulta.",
      bill_alert_body: "Ogni giorno che passa stai pagando acqua che non usi (e i ripristini diventano più cari). Parla con un tecnico: al telefono inquadriamo il problema e concordiamo il sopralluogo in base a zona e disponibilità.",
      why_us_title: "Perché sceglierci",
      why_us_items: [
        { t: "Senza demolizioni inutili", d: "Geofono HL7000, termocamera FLIR e gas tracciante non tossico: apertura mirata solo nel punto individuato, invece di muri demoliti a caso." },
        { t: "Reperibilità H24", d: "Rispondiamo al telefono 7 giorni su 7 e concordiamo l'orario dell'intervento in base alla zona e alla disponibilità, dalla nostra sede di Massa e Cozzile (PT)." },
        { t: "Foto-report incluso", d: "Video e foto dell'intervento, utili per assicurazione, condominio o gestore idrico. Niente parole, prove." },
        { t: "Preventivo scritto prima di iniziare", d: "Costi chiari e concordati prima del sopralluogo, messi per iscritto nel preventivo." },
      ],
    },
    trust: {
      title: "Cosa ti garantiamo per iscritto",
      sub: "Solo impegni che puoi verificare al telefono o nel preventivo. Niente numeri non documentati.",
      counter_reviews: "Recensioni sul profilo Business ufficiale",
      counter_quote: "Preventivo prima di iniziare",
      counter_report: "Foto e relazione tecnica",
      counter_h24: "365 giorni l'anno, festivi inclusi",
    },
    lp_ads: {
      seo_title: "SOS Perdite Acqua Toscana \u2014 Tecnico reperibile H24 | Bagnoman",
      seo_desc: "Ricerca perdite acqua senza demolizioni inutili in tutta la Toscana. Geofono + termocamera + gas tracciante. Sopralluogo da 99\u20ac. Preventivo scritto prima di iniziare.",
      eyebrow: "PRONTO INTERVENTO PERDITE ACQUA",
      h1: "Perdita d'acqua? La localizziamo senza demolizioni inutili.",
      sub: "Tutta la Toscana \u2014 reperibilità telefonica H24, intervento concordato in base alla zona. Diagnosi con geofono HL7000, termocamera FLIR e gas tracciante non tossico. Sopralluogo da 99\u20ac. Foto-report incluso.",
      cta_call: "Chiama subito 351 062 4386",
      cta_whatsapp: "Scrivi su WhatsApp",
      cta_quote: "Calcola preventivo",
      guarantee_title: "Preventivo scritto prima di iniziare",
      guarantee_body: "Costi del sopralluogo e della diagnosi indicati per iscritto nel preventivo, prima di iniziare. Nessun extra non concordato.",
      form_title: "Richiamami appena possibile",
      form_sub: "Lascia nome, telefono e zona: ti richiamiamo appena possibile, anche su WhatsApp.",
      form_name: "Nome",
      form_phone: "Telefono",
      form_zone: "Citt\u00e0 o zona",
      form_problem: "Descrivi il problema (1 riga)",
      form_submit: "Voglio essere richiamato",
      form_ok: "Richiesta ricevuta! Ti richiamiamo al più presto.",
      form_err: "Errore di invio: chiama direttamente 351 062 4386.",
      proof_title: "Alcuni interventi documentati",
      footer_legal: "Bagnoman \u00b7 All Service di La Rocca Cristian \u00b7 P.IVA IT02132210473 \u00b7 Via Marconi 33, 51010 Massa e Cozzile (PT) \u00b7 H24 \u00b7 Tel +39 351 062 4386",
    },
    services_page: {
      title: "I nostri servizi",
      sub: "Ricerca perdite, infiltrazioni, impianti antincendio — una soluzione per ogni problema d'acqua.",
    },
    equipment_page: {
      title: "Attrezzature professionali",
      sub: "Ogni strumento ha il suo uso. Ecco quelli che cambiano davvero il risultato.",
    },
    gallery_page: {
      title: "Galleria interventi",
      sub: "Foto dei nostri sopralluoghi e riparazioni.",
    },
    blog_page: {
      title: "Blog — guide pratiche",
      sub: "Consigli per riconoscere perdite, capire la bolletta, scegliere il giusto intervento.",
      read: "Leggi",
      min: "min",
    },
    reviews_page: {
      title: "Recensioni clienti",
      sub: "Recensioni pubblicate solo sul profilo Google Business ufficiale.",
      submit_open: "Scrivi una recensione",
      submit_title: "Lascia la tua recensione",
      submitted: "Grazie! Recensione inviata.",
      filter_all: "Tutte le province",
    },
    contact_page: {
      title: "Contattaci",
      sub: "Reperibilità telefonica H24. Ti richiamiamo appena possibile.",
      form_title: "Richiedi un intervento",
      submitted: "Richiesta ricevuta. Ti contattiamo a breve.",
      error: "Errore nell'invio. Riprova o chiamaci.",
    },
    about_page: {
      title: "Chi siamo",
      sub: "Ditta individuale specializzata in ricerca perdite e infiltrazioni, con sede a Massa e Cozzile (PT).",
    },
    province_page: {
      h1_template: "Ricerca perdite acqua a {p}: la localizziamo con precisione, senza demolizioni inutili",
      title_template: "Ricerca perdite acqua in provincia di {p}: tutti i comuni, reperibilit\u00e0 H24",
      sub_template: "Reperibilità telefonica H24 per {p} e provincia. Geofono HL7000, termocamera FLIR, gas tracciante. Preventivo scritto prima di iniziare.",
      steps_title: "Come lavoriamo a {p}",
      faq_title: "Domande frequenti — {p}",
      cta_title: "Perdita d'acqua a {p}? Parliamone subito al telefono.",
      cta_sub: "Rispondiamo al telefono anche di notte e nei festivi. Concordiamo il sopralluogo su {p} in base a zona e disponibilità, con preventivo scritto prima di iniziare.",
      symptoms_title: "Ti suona familiare uno di questi sintomi a {p}?",
    },
    chat: {
      teaser: "Hai un'emergenza? Ti faccio 4 domande e ti dico cosa fare subito.",
      title: "Assistente All Service",
      online: "Online H24",
      placeholder: "Scrivi il tuo problema...",
      send: "Invia",
      greeting: "Ciao! Sono l'assistente AI di All Service Toscana. Dimmi cosa sta succedendo: perdita, infiltrazione o bolletta strana?\n\nSe \u00e8 un'emergenza, puoi chiamarci subito al +39 351 062 4386 oppure premi il microfono qui sotto e parlami.",
      thinking: "Sto scrivendo...",
    },
    form: {
      name: "Nome e cognome",
      phone: "Telefono",
      email: "Email (opzionale)",
      province: "Provincia",
      message: "Descrivi il problema",
      service_type: "Tipo di servizio",
      urgency: "Urgenza",
      urgency_high: "Emergenza adesso",
      urgency_normal: "Entro 24h",
      urgency_low: "In settimana",
      select_province: "Seleziona provincia",
      select_service: "Seleziona servizio",
      consent: "Accetto il trattamento dei dati per essere ricontattato/a.",
      rating: "Voto",
    },
    footer: {
      tagline: "Pronto intervento ricerca perdite e infiltrazioni in Toscana, Liguria, Umbria e Alto Lazio.",
      links: "Link utili",
      areas: "Zone servite",
      contact: "Contatti",
      legal: "© {year} All Service di La Rocca Cristian — P.IVA IT02132210473 — Via G. Marconi 33, 51010 Massa e Cozzile (PT). Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      home: "Home", services: "Services", equipment: "Equipment", gallery: "Gallery",
      blog: "Blog", reviews: "Reviews", areas: "Areas", about: "About", contact: "Contact",
      call: "Call", whatsapp: "WhatsApp", emergency: "24/7 Emergency",
    },
    common: {
      call_now: "Talk to a technician", call_now_short: "Call 24/7", whatsapp: "WhatsApp", get_quote: "Get a quote",
      open_chat: "Open assistant", h24: "24/7", open_now: "Available now",
      free_quote: "Free quote", learn_more: "Learn more", read_more: "Read more",
      submit: "Send", sending: "Sending...", back: "Back", view_all: "View all",
      areas_we_serve: "Areas we serve", see_all_areas: "See all areas",
      our_equipment: "Our equipment",
    },
    hero: {
      eyebrow: "Water leak emergency • Phone availability 24/7",
      h1_line1: "We find the leak",
      h1_line2: "without needless demolition.",
      sub: "Water leak detection in Tuscany, Liguria, Umbria and Upper Lazio. HL7000 geophone, FLIR thermal camera and non-toxic tracer gas. Quote before we start, photo-report at the end.",
      trust: ["Non-invasive diagnosis where possible", "Written quote before we start", "Photo-report included"],
    },
    home: {
      services_title: "What we fix",
      services_sub: "Anything water-related — with professional tools and zero panic.",
      equipment_title: "Precision equipment",
      equipment_sub: "No random demolition. Just targeted diagnosis.",
      gallery_title: "Recent jobs",
      gallery_sub: "Real photos of our inspections and repairs.",
      reviews_title: "What customers say",
      reviews_sub: "Reviews published on our Google Business profile.",
      coverage_title: "Where we operate",
      coverage_sub: "15 provinces in Tuscany, Liguria, Umbria and Upper Lazio.",
      faq_title: "Frequently asked",
      bill_alert_title: "Water bill way too high?",
      bill_alert_body: "It is often a hidden leak. Call us: we assess the problem by phone and schedule the visit based on your area.",
      why_us_title: "Why us",
      why_us_items: [
        { t: "No needless demolition", d: "HL7000 geophone, FLIR thermal camera and non-toxic tracer gas: a targeted opening only at the located point, instead of walls broken at random." },
        { t: "24/7 availability", d: "We answer the phone 7 days a week and schedule the visit based on your area and our availability, from our base in Massa e Cozzile (PT)." },
        { t: "Photo-report included", d: "Photos and video of the job, ready for insurance, condo board or water provider. Evidence, not promises." },
        { t: "Written quote before we start", d: "Clear costs agreed before the visit and written in the quote." },
      ],
    },
    trust: {
      title: "What we commit to in writing",
      sub: "Only commitments you can verify by phone or in the quote. No undocumented numbers.",
      counter_reviews: "Reviews on the official Business profile",
      counter_quote: "Quote before we start",
      counter_report: "Photos and technical report",
      counter_h24: "365 days a year, holidays included",
    },
    lp_ads: {
      seo_title: "SOS Water Leaks Tuscany \u2014 Technician available 24/7 | Bagnoman",
      seo_desc: "Water leak detection across Tuscany without needless demolition. Geophone + thermal + tracer gas. Visit from \u20ac99. Written quote before we start.",
      eyebrow: "WATER LEAK EMERGENCY",
      h1: "Water leak? Located without needless demolition.",
      sub: "All of Tuscany \u2014 phone availability 24/7, visit scheduled by area. HL7000 geophone, FLIR thermal camera, non-toxic tracer gas. Visits from \u20ac99. Photo-report included.",
      cta_call: "Call now 351 062 4386",
      cta_whatsapp: "WhatsApp us",
      cta_quote: "Get a quote",
      guarantee_title: "Written quote before we start",
      guarantee_body: "Visit and diagnosis costs stated in writing in the quote before we start. No unagreed extras.",
      form_title: "Call me back as soon as possible",
      form_sub: "Leave your name, phone and area: we call you back as soon as possible, also on WhatsApp.",
      form_name: "Name",
      form_phone: "Phone",
      form_zone: "City or area",
      form_problem: "Describe the issue (1 line)",
      form_submit: "Call me back",
      form_ok: "Request received! We call you back as soon as possible.",
      form_err: "Submission error: please call 351 062 4386 directly.",
      proof_title: "Some documented jobs",
      footer_legal: "Bagnoman \u00b7 All Service di La Rocca Cristian \u00b7 VAT IT02132210473 \u00b7 Via Marconi 33, 51010 Massa e Cozzile (PT) \u00b7 24/7 \u00b7 Tel +39 351 062 4386",
    },
    services_page: { title: "Our services", sub: "Leak detection, infiltrations, fire systems — one solution per water problem." },
    equipment_page: { title: "Professional equipment", sub: "Every tool has its purpose. The ones that actually change the outcome." },
    gallery_page: { title: "Job gallery", sub: "Photos from our inspections and repairs." },
    blog_page: { title: "Blog — practical guides", sub: "How to spot leaks, understand bills, pick the right service.", read: "Read", min: "min" },
    reviews_page: { title: "Customer reviews", sub: "Reviews published only on the official Google Business profile.", submit_open: "Write a review", submit_title: "Leave your review", submitted: "Thanks! Review submitted.", filter_all: "All provinces" },
    contact_page: { title: "Contact us", sub: "Phone availability 24/7. We call back as soon as possible.", form_title: "Request a visit", submitted: "Request received. We'll contact you shortly.", error: "Submission error. Try again or call us." },
    about_page: { title: "About us", sub: "Leak and infiltration specialists in Tuscany and Umbria." },
    province_page: {
      h1_template: "Water leak detection in {p}: we locate it precisely, without needless demolition",
      title_template: "Water leak detection in the province of {p}: every municipality, 24/7 phone availability",
      sub_template: "Phone availability 24/7 for {p} and province. HL7000 geophone, FLIR thermal camera, tracer gas. Written quote before we start.",
      steps_title: "How we work in {p}",
      faq_title: "Frequently asked — {p}",
      cta_title: "Water leak in {p}? Let's talk about it now.",
      cta_sub: "We answer the phone nights and holidays too. We schedule the visit in {p} based on area and availability, with a written quote before we start.",
      symptoms_title: "Do any of these symptoms sound familiar in {p}?",
    },
    chat: {
      teaser: "Emergency? I'll ask 4 questions and tell you what to do.",
      title: "All Service Assistant",
      online: "Online 24/7",
      placeholder: "Type your problem...",
      send: "Send",
      greeting: "Hi! I'm the All Service Toscana AI assistant. Tell me what's going on: a leak, infiltration or odd bill?\n\nIf it's an emergency, you can call us right now at +39 351 062 4386 or tap the microphone below and talk to me.",
      thinking: "Typing...",
    },
    form: {
      name: "Full name", phone: "Phone", email: "Email (optional)", province: "Province",
      message: "Describe the problem", service_type: "Service type", urgency: "Urgency",
      urgency_high: "Emergency now", urgency_normal: "Within 24h", urgency_low: "This week",
      select_province: "Select province", select_service: "Select service",
      consent: "I accept data processing for callback.", rating: "Rating",
    },
    footer: {
      tagline: "24/7 leak and infiltration emergency in Tuscany, Liguria, Umbria and Upper Lazio.",
      links: "Useful links", areas: "Areas", contact: "Contact",
      legal: "© {year} All Service di La Rocca Cristian — VAT IT02132210473 — Via G. Marconi 33, 51010 Massa e Cozzile (PT), Italy. All rights reserved.",
    },
  },
};
